import { Link } from "react-router-dom";
import { Facebook, Instagram, Linkedin, Youtube, Mail, Phone, ArrowRight, Heart } from "react-feather";
import { FaWhatsapp } from "react-icons/fa";
import "./Footer.css";
import img from "../../Logo/logo2.jpg";

function Footer() {
  return (
    <footer className="ft">
      {/* Top shimmer line */}
      <div className="ft-topline"></div>

      {/* Floating hearts */}
      <div className="ft-bg">
        {["♥","♥","♥","♥","♥","♥"].map((h, i) => (
          <span key={i} className={`ft-heart ft-h${i}`}>{h}</span>
        ))}
      </div>

      <div className="ft-wrap">

        {/* Row 1: Brand + Links */}
        <div className="ft-main">

          {/* Brand */}
          <div className="ft-brand">
            <div className="ft-logo-row">
              <img src={img} alt="Logo" className="ft-logo" />
              <div>
                <h3 className="ft-brand-name">Community <span>Rishtey</span></h3>
                <p className="ft-brand-tag">Trusted Matrimony Platform</p>
              </div>
            </div>
            <p className="ft-brand-desc">
              Connecting hearts with trust, compatibility & meaningful relationships.
            </p>
          </div>

          {/* Quick Links */}
          <div className="ft-col">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/Froud_Alert">Fraud Alert</Link></li>
              <li><Link to="/Term_Use">Terms of Use</Link></li>
              <li><Link to="/Privacy_Policy">Privacy Policy</Link></li>
              <li><Link to="/Privacy_Features">Privacy Features</Link></li>
              <li><Link to="/staff_login">Partner Registration</Link></li>
               <li><Link to="/services">Our Services</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="ft-col">
            <h4>Contact Us</h4>
            <div className="ft-contact-item">
              <div className="ft-icon-circle"><Mail size={14} /></div>
              <a href="mailto:communityrishtey@gmail.com">communityrishtey@gmail.com</a>
            </div>
            <div className="ft-contact-item">
              <div className="ft-icon-circle"><Phone size={14} /></div>
              <a href="tel:+918962813719">+91-8962813719</a>
            </div>
            <Link to="/contact" className="ft-contact-btn">
              Get in Touch <ArrowRight size={14} />
            </Link>
          </div>

          {/* Social */}
          <div className="ft-col">
            <h4>Follow Us</h4>
            <div className="ft-socials">
              <a href="https://www.facebook.com/" target="_blank" rel="noreferrer" aria-label="Facebook"><Facebook size={16} /></a>
              <a href="https://www.instagram.com/community_rishtey?igsh=MXVncTd3cW5jbG5hYg==" target="_blank" rel="noreferrer" aria-label="Instagram"><Instagram size={16} /></a>
              <a href="https://wa.me/918962813719?text=Hello%20I%20want%20to%20know%20more%20about%20your%20services" target="_blank" rel="noreferrer" aria-label="WhatsApp"><FaWhatsapp size={17} /></a>
              <a href="https://www.linkedin.com/in/community-rishtey-342479385/" target="_blank" rel="noreferrer" aria-label="LinkedIn"><Linkedin size={16} /></a>
              <a href="https://youtube.com/@communityrishtey1713?si=2yXyxGlkvqHKRmNx" target="_blank" rel="noreferrer" aria-label="YouTube"><Youtube size={16} /></a>
            </div>
            <div className="ft-mini-trust">
              <span>Verified</span>
              <span>Secure</span>
              <span>Trusted</span>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="ft-divider"></div>

        {/* Bottom */}
        <div className="ft-bottom">

          {/* Center: Copyright */}
          <p className="ft-copy">© 2025 Community Rishtey. All rights reserved.</p>

          {/* Right: Made with */}
          <p className="ft-made">Made with <Heart size={13} className="ft-heart-icon" /> and elegance</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;